export default __webpack_public_path__ + "static/media/prev-GNSS-Antenna-1.d4a1b7c8.png";